import React from "react";
export default function useConfirmation(action: any) {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const toPromise = React.useCallback(() => {
    return new Promise((resolve) => {
      resolve(action());
    });
  }, [action]);

  const toggleOpen = React.useCallback(
    (): void => setIsOpen((isOpen) => !isOpen),
    []
  );

  const performAction = React.useCallback(() => {
    setIsLoading(true);
    toPromise().then(() => {
      setIsLoading(false);
    });
  }, [toPromise]);

  return {
    dialogOpen: isOpen,
    loading: isLoading,
    toggleOpen,
    performAction,
  };
}
